
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexHHK1O5xtNRwzppgDqaKUkb465_452DL1V3nHX_wEieVUIMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/index.vue?macro=true";
import { default as sobrexDZ7m0LNco3Dw2XmBKHB5GUtVY5SFkXy9skctfxmUaQMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/sobre.vue?macro=true";
import { default as contatoPfMtwgaxk7oeNMpvcGjhFeqRiFeNtcQeDbAU6EiwzawMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/contato.vue?macro=true";
import { default as index0HHvSK8ECiaL_4jYC7wvGfbVi7_45B9qinRv6z2TQjtw0Meta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/blog/index.vue?macro=true";
import { default as indexdutGfzGxoFsDhGrGVUD1_45mNkVog1t094b8tVJr4eXeIMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/index.vue?macro=true";
import { default as _91slug_932icIprDS0eHFLe2sgl1bNhmjBK3qI_E4KpStHNEapWsMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/blog/[slug].vue?macro=true";
import { default as privacidadewkAqHNiV3Le3oYzukBx9IXgV81zBJkDg8CbJqAs4TTEMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/privacidade.vue?macro=true";
import { default as agradecimentor5iMtWCEmckhOclPEVc0nACScbvRW34cx_TtjaYVm9gMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/agradecimento.vue?macro=true";
import { default as indexAKtfZTwE_iRtcFc_45Sq1IEWyzyudc3ISjPt0Z3JYuY6kMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/clinicas/index.vue?macro=true";
import { default as _91slug_93KpZgO_mvy7KkzPOUMm5u2tSUrWZedp400XqK68O2AG8Meta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/clinicas/[slug].vue?macro=true";
import { default as indexE1Ow8E5pIFhP5eEQ0Bec0_45AxYASVMyMWVq1owYCA8RwMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/leads/index.vue?macro=true";
import { default as indexAiowjlUSkSzIYnHVMzag3tBf18SBUfCJZmcuQ766tj8Meta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/login/index.vue?macro=true";
import { default as indexFoq97sLk8vO98KJ_Ztf5cfHTJCavWa0zq7_4cR7aJkAMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/posts/index.vue?macro=true";
import { default as index1rtlSDDyI9L8_451io4NS3eQE3rKKLgHJi3MBmhMH5sYAMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/tratamentos/index.vue?macro=true";
import { default as _91slug_9384klzGjbY32q9XpaBI0pNY_45SeyJz_u5_0mMNZzdn_45JQMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/tratamentos/[slug].vue?macro=true";
import { default as indexTd7zzS7rvSDNBm9oY8ai8aPbmGweJU1Z7uhcmHZ31FYMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/banners/index.vue?macro=true";
import { default as indexpb5eeAnVkLpVXTEo7gR9Hvhb6XL1GzzB0EMBaHlPsKEMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/clinicas/index.vue?macro=true";
import { default as indexXVY2v9AsucuppcTEYbJTlInF7migYNC7MEeUvntUhEIMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/usuarios/index.vue?macro=true";
import { default as indexniznlHL9cz7cZ_QQlzBxD4tpZ_9txPslWDqACgudtqEMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/leads/[id]/index.vue?macro=true";
import { default as indexiK6TsFkS0XRgiFIrD_45QX1S9zp21zbsdRSh_eiggfSpIMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/posts/[id]/index.vue?macro=true";
import { default as indexrrcrMUG5_45H_45PtVPSc3lZ0sxTyHuIUrAUAsroqPYlBD0Meta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/depoimentos/index.vue?macro=true";
import { default as index1RsS97x3wHi22lEWtjaGotjCTpNv4pIsmImASX2QBoQMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/index.vue?macro=true";
import { default as indexEfuHaf0EaZuYumWHzqZZ_NcmmYo0X8kEtdqefWFZWhYMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/banners/[id]/index.vue?macro=true";
import { default as indexe_45hf3f1PfT8RTEvz4AZm_45ogxi8BsVAmSZp20HmsWoi8Meta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/usuarios/[id]/index.vue?macro=true";
import { default as indexjU94B2h4HQNhKJz0UF4yBMrkvqleMNOWEGPQODDk5DgMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/depoimentos/[id]/index.vue?macro=true";
import { default as indexYHfy6wGE6_45HY98DPndVVWTbjVTGRbRM6HZQnbofQSGsMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/clinicas/[clinica]/index.vue?macro=true";
import { default as index_450mDDB2TN4qK0pJDC5tOuQIj3XSdqzrKhNBOUi8FYGsMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/[tratamento]/index.vue?macro=true";
import { default as index6Ws9uHKiGyp3uHq4rjRoVE4PNMBX_dVEB_AsmVdIWroMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/clinicas/[clinica]/imagens/index.vue?macro=true";
import { default as _91imagem_93Q3IfGC1TzrtQlaKw_JvGe4VrHG80RJzMS6vnt6lD06oMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/clinicas/[clinica]/imagens/[imagem].vue?macro=true";
import { default as indexdqrKf40m1xxMaBmraR2l93XMkzWypbnhMAHQTyIiU8wMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/[tratamento]/tipos/index.vue?macro=true";
import { default as _91tipo_93vLdGoxOKj_4528t83r_45GjKEzQyDH3Gl17lpr4MPCZ2_1oMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/[tratamento]/tipos/[tipo].vue?macro=true";
import { default as index4JGeJgYREnhpEZYSlAjww1VxU7p_45HA1V0PHxLBSz_45y8Meta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/[tratamento]/vantagens/index.vue?macro=true";
import { default as _91vantagem_93ioqs6NhspIyUhUQ10_96bh_45ujf6Rlur5O4PrTERp2UQMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/[tratamento]/vantagens/[vantagem].vue?macro=true";
import { default as component_45stubkYH7QRr2aeWxYjsylrfhyRscvAltXUSXtjFG0dNMRyMMeta } from "/Users/gabrielfritsch/projetos/sorrifacil-site/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubkYH7QRr2aeWxYjsylrfhyRscvAltXUSXtjFG0dNMRyM } from "/Users/gabrielfritsch/projetos/sorrifacil-site/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___pt",
    path: "/",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/index.vue")
  },
  {
    name: "sobre___pt",
    path: "/sobre",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/sobre.vue")
  },
  {
    name: "sobre___es",
    path: "/es/sobre",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/sobre.vue")
  },
  {
    name: "contato___pt",
    path: "/contato",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/contato.vue")
  },
  {
    name: "contato___es",
    path: "/es/contato",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/contato.vue")
  },
  {
    name: "blog___pt",
    path: "/blog",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/blog/index.vue")
  },
  {
    name: "blog___es",
    path: "/es/blog",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/blog/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexdutGfzGxoFsDhGrGVUD1_45mNkVog1t094b8tVJr4eXeIMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/index.vue")
  },
  {
    name: "blog-slug___pt",
    path: "/blog/:slug()",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___es",
    path: "/es/blog/:slug()",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/blog/[slug].vue")
  },
  {
    name: "privacidade___pt",
    path: "/privacidade",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/privacidade.vue")
  },
  {
    name: "privacidade___es",
    path: "/es/privacidade",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/privacidade.vue")
  },
  {
    name: "agradecimento___pt",
    path: "/agradecimento",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/agradecimento.vue")
  },
  {
    name: "agradecimento___es",
    path: "/es/agradecimento",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/agradecimento.vue")
  },
  {
    name: "clinicas___pt",
    path: "/clinicas",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/clinicas/index.vue")
  },
  {
    name: "clinicas___es",
    path: "/es/clinicas",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/clinicas/index.vue")
  },
  {
    name: "clinicas-slug___pt",
    path: "/clinicas/:slug()",
    meta: _91slug_93KpZgO_mvy7KkzPOUMm5u2tSUrWZedp400XqK68O2AG8Meta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/clinicas/[slug].vue")
  },
  {
    name: "clinicas-slug___es",
    path: "/es/clinicas/:slug()",
    meta: _91slug_93KpZgO_mvy7KkzPOUMm5u2tSUrWZedp400XqK68O2AG8Meta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/clinicas/[slug].vue")
  },
  {
    name: "admin-leads",
    path: "/admin/leads",
    meta: indexE1Ow8E5pIFhP5eEQ0Bec0_45AxYASVMyMWVq1owYCA8RwMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/leads/index.vue")
  },
  {
    name: "admin-login___pt",
    path: "/admin/login",
    meta: indexAiowjlUSkSzIYnHVMzag3tBf18SBUfCJZmcuQ766tj8Meta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/login/index.vue")
  },
  {
    name: "admin-login___es",
    path: "/es/admin/login",
    meta: indexAiowjlUSkSzIYnHVMzag3tBf18SBUfCJZmcuQ766tj8Meta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/login/index.vue")
  },
  {
    name: "admin-posts___pt",
    path: "/admin/posts",
    meta: indexFoq97sLk8vO98KJ_Ztf5cfHTJCavWa0zq7_4cR7aJkAMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/posts/index.vue")
  },
  {
    name: "admin-posts___es",
    path: "/es/admin/posts",
    meta: indexFoq97sLk8vO98KJ_Ztf5cfHTJCavWa0zq7_4cR7aJkAMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/posts/index.vue")
  },
  {
    name: "tratamentos___pt",
    path: "/tratamentos",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/tratamentos/index.vue")
  },
  {
    name: "tratamentos___es",
    path: "/es/tratamentos",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/tratamentos/index.vue")
  },
  {
    name: "tratamentos-slug___pt",
    path: "/tratamentos/:slug()",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/tratamentos/[slug].vue")
  },
  {
    name: "tratamentos-slug___es",
    path: "/es/tratamentos/:slug()",
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/tratamentos/[slug].vue")
  },
  {
    name: "admin-banners___pt",
    path: "/admin/banners",
    meta: indexTd7zzS7rvSDNBm9oY8ai8aPbmGweJU1Z7uhcmHZ31FYMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/banners/index.vue")
  },
  {
    name: "admin-banners___es",
    path: "/es/admin/banners",
    meta: indexTd7zzS7rvSDNBm9oY8ai8aPbmGweJU1Z7uhcmHZ31FYMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/banners/index.vue")
  },
  {
    name: "admin-clinicas___pt",
    path: "/admin/clinicas",
    meta: indexpb5eeAnVkLpVXTEo7gR9Hvhb6XL1GzzB0EMBaHlPsKEMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/clinicas/index.vue")
  },
  {
    name: "admin-clinicas___es",
    path: "/es/admin/clinicas",
    meta: indexpb5eeAnVkLpVXTEo7gR9Hvhb6XL1GzzB0EMBaHlPsKEMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/clinicas/index.vue")
  },
  {
    name: "admin-usuarios___pt",
    path: "/admin/usuarios",
    meta: indexXVY2v9AsucuppcTEYbJTlInF7migYNC7MEeUvntUhEIMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/usuarios/index.vue")
  },
  {
    name: "admin-usuarios___es",
    path: "/es/admin/usuarios",
    meta: indexXVY2v9AsucuppcTEYbJTlInF7migYNC7MEeUvntUhEIMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/usuarios/index.vue")
  },
  {
    name: "admin-leads-id___pt",
    path: "/admin/leads/:id()",
    meta: indexniznlHL9cz7cZ_QQlzBxD4tpZ_9txPslWDqACgudtqEMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/leads/[id]/index.vue")
  },
  {
    name: "admin-leads-id___es",
    path: "/es/admin/leads/:id()",
    meta: indexniznlHL9cz7cZ_QQlzBxD4tpZ_9txPslWDqACgudtqEMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/leads/[id]/index.vue")
  },
  {
    name: "admin-posts-id___pt",
    path: "/admin/posts/:id()",
    meta: indexiK6TsFkS0XRgiFIrD_45QX1S9zp21zbsdRSh_eiggfSpIMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/posts/[id]/index.vue")
  },
  {
    name: "admin-posts-id___es",
    path: "/es/admin/posts/:id()",
    meta: indexiK6TsFkS0XRgiFIrD_45QX1S9zp21zbsdRSh_eiggfSpIMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/posts/[id]/index.vue")
  },
  {
    name: "admin-depoimentos___pt",
    path: "/admin/depoimentos",
    meta: indexrrcrMUG5_45H_45PtVPSc3lZ0sxTyHuIUrAUAsroqPYlBD0Meta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/depoimentos/index.vue")
  },
  {
    name: "admin-depoimentos___es",
    path: "/es/admin/depoimentos",
    meta: indexrrcrMUG5_45H_45PtVPSc3lZ0sxTyHuIUrAUAsroqPYlBD0Meta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/depoimentos/index.vue")
  },
  {
    name: "admin-tratamentos___pt",
    path: "/admin/tratamentos",
    meta: index1RsS97x3wHi22lEWtjaGotjCTpNv4pIsmImASX2QBoQMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/index.vue")
  },
  {
    name: "admin-tratamentos___es",
    path: "/es/admin/tratamentos",
    meta: index1RsS97x3wHi22lEWtjaGotjCTpNv4pIsmImASX2QBoQMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/index.vue")
  },
  {
    name: "admin-banners-id___pt",
    path: "/admin/banners/:id()",
    meta: indexEfuHaf0EaZuYumWHzqZZ_NcmmYo0X8kEtdqefWFZWhYMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/banners/[id]/index.vue")
  },
  {
    name: "admin-banners-id___es",
    path: "/es/admin/banners/:id()",
    meta: indexEfuHaf0EaZuYumWHzqZZ_NcmmYo0X8kEtdqefWFZWhYMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/banners/[id]/index.vue")
  },
  {
    name: "admin-usuarios-id___pt",
    path: "/admin/usuarios/:id()",
    meta: indexe_45hf3f1PfT8RTEvz4AZm_45ogxi8BsVAmSZp20HmsWoi8Meta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/usuarios/[id]/index.vue")
  },
  {
    name: "admin-usuarios-id___es",
    path: "/es/admin/usuarios/:id()",
    meta: indexe_45hf3f1PfT8RTEvz4AZm_45ogxi8BsVAmSZp20HmsWoi8Meta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/usuarios/[id]/index.vue")
  },
  {
    name: "admin-depoimentos-id___pt",
    path: "/admin/depoimentos/:id()",
    meta: indexjU94B2h4HQNhKJz0UF4yBMrkvqleMNOWEGPQODDk5DgMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/depoimentos/[id]/index.vue")
  },
  {
    name: "admin-depoimentos-id___es",
    path: "/es/admin/depoimentos/:id()",
    meta: indexjU94B2h4HQNhKJz0UF4yBMrkvqleMNOWEGPQODDk5DgMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/depoimentos/[id]/index.vue")
  },
  {
    name: "admin-clinicas-clinica___pt",
    path: "/admin/clinicas/:clinica()",
    meta: indexYHfy6wGE6_45HY98DPndVVWTbjVTGRbRM6HZQnbofQSGsMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/clinicas/[clinica]/index.vue")
  },
  {
    name: "admin-clinicas-clinica___es",
    path: "/es/admin/clinicas/:clinica()",
    meta: indexYHfy6wGE6_45HY98DPndVVWTbjVTGRbRM6HZQnbofQSGsMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/clinicas/[clinica]/index.vue")
  },
  {
    name: "admin-tratamentos-tratamento___pt",
    path: "/admin/tratamentos/:tratamento()",
    meta: index_450mDDB2TN4qK0pJDC5tOuQIj3XSdqzrKhNBOUi8FYGsMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/[tratamento]/index.vue")
  },
  {
    name: "admin-tratamentos-tratamento___es",
    path: "/es/admin/tratamentos/:tratamento()",
    meta: index_450mDDB2TN4qK0pJDC5tOuQIj3XSdqzrKhNBOUi8FYGsMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/[tratamento]/index.vue")
  },
  {
    name: "admin-clinicas-clinica-imagens___pt",
    path: "/admin/clinicas/:clinica()/imagens",
    meta: index6Ws9uHKiGyp3uHq4rjRoVE4PNMBX_dVEB_AsmVdIWroMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/clinicas/[clinica]/imagens/index.vue")
  },
  {
    name: "admin-clinicas-clinica-imagens___es",
    path: "/es/admin/clinicas/:clinica()/imagens",
    meta: index6Ws9uHKiGyp3uHq4rjRoVE4PNMBX_dVEB_AsmVdIWroMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/clinicas/[clinica]/imagens/index.vue")
  },
  {
    name: "admin-clinicas-clinica-imagens-imagem___pt",
    path: "/admin/clinicas/:clinica()/imagens/:imagem()",
    meta: _91imagem_93Q3IfGC1TzrtQlaKw_JvGe4VrHG80RJzMS6vnt6lD06oMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/clinicas/[clinica]/imagens/[imagem].vue")
  },
  {
    name: "admin-clinicas-clinica-imagens-imagem___es",
    path: "/es/admin/clinicas/:clinica()/imagens/:imagem()",
    meta: _91imagem_93Q3IfGC1TzrtQlaKw_JvGe4VrHG80RJzMS6vnt6lD06oMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/clinicas/[clinica]/imagens/[imagem].vue")
  },
  {
    name: "admin-tratamentos-tratamento-tipos___pt",
    path: "/admin/tratamentos/:tratamento()/tipos",
    meta: indexdqrKf40m1xxMaBmraR2l93XMkzWypbnhMAHQTyIiU8wMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/[tratamento]/tipos/index.vue")
  },
  {
    name: "admin-tratamentos-tratamento-tipos___es",
    path: "/es/admin/tratamentos/:tratamento()/tipos",
    meta: indexdqrKf40m1xxMaBmraR2l93XMkzWypbnhMAHQTyIiU8wMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/[tratamento]/tipos/index.vue")
  },
  {
    name: "admin-tratamentos-tratamento-tipos-tipo___pt",
    path: "/admin/tratamentos/:tratamento()/tipos/:tipo()",
    meta: _91tipo_93vLdGoxOKj_4528t83r_45GjKEzQyDH3Gl17lpr4MPCZ2_1oMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/[tratamento]/tipos/[tipo].vue")
  },
  {
    name: "admin-tratamentos-tratamento-tipos-tipo___es",
    path: "/es/admin/tratamentos/:tratamento()/tipos/:tipo()",
    meta: _91tipo_93vLdGoxOKj_4528t83r_45GjKEzQyDH3Gl17lpr4MPCZ2_1oMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/[tratamento]/tipos/[tipo].vue")
  },
  {
    name: "admin-tratamentos-tratamento-vantagens___pt",
    path: "/admin/tratamentos/:tratamento()/vantagens",
    meta: index4JGeJgYREnhpEZYSlAjww1VxU7p_45HA1V0PHxLBSz_45y8Meta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/[tratamento]/vantagens/index.vue")
  },
  {
    name: "admin-tratamentos-tratamento-vantagens___es",
    path: "/es/admin/tratamentos/:tratamento()/vantagens",
    meta: index4JGeJgYREnhpEZYSlAjww1VxU7p_45HA1V0PHxLBSz_45y8Meta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/[tratamento]/vantagens/index.vue")
  },
  {
    name: "admin-tratamentos-tratamento-vantagens-vantagem___pt",
    path: "/admin/tratamentos/:tratamento()/vantagens/:vantagem()",
    meta: _91vantagem_93ioqs6NhspIyUhUQ10_96bh_45ujf6Rlur5O4PrTERp2UQMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/[tratamento]/vantagens/[vantagem].vue")
  },
  {
    name: "admin-tratamentos-tratamento-vantagens-vantagem___es",
    path: "/es/admin/tratamentos/:tratamento()/vantagens/:vantagem()",
    meta: _91vantagem_93ioqs6NhspIyUhUQ10_96bh_45ujf6Rlur5O4PrTERp2UQMeta || {},
    component: () => import("/Users/gabrielfritsch/projetos/sorrifacil-site/pages/admin/tratamentos/[tratamento]/vantagens/[vantagem].vue")
  },
  {
    name: component_45stubkYH7QRr2aeWxYjsylrfhyRscvAltXUSXtjFG0dNMRyMMeta?.name,
    path: "/saiba-mais-site-v1",
    component: component_45stubkYH7QRr2aeWxYjsylrfhyRscvAltXUSXtjFG0dNMRyM
  },
  {
    name: component_45stubkYH7QRr2aeWxYjsylrfhyRscvAltXUSXtjFG0dNMRyMMeta?.name,
    path: "/franquia",
    component: component_45stubkYH7QRr2aeWxYjsylrfhyRscvAltXUSXtjFG0dNMRyM
  }
]